"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var react_prop_types_1 = require("../react-prop-types");
var owner_document_1 = require("./utils/owner-document");
var get_container_1 = require("./utils/get-container");
/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isMounted = false;
        _this._mountOverlayTarget = function () {
            if (!_this._overlayTarget) {
                _this._overlayTarget = document.createElement('div');
                _this._portalContainerNode = get_container_1.getContainer(_this.props.container, owner_document_1.ownerDocument(_this).body);
                _this._portalContainerNode.appendChild(_this._overlayTarget);
            }
        };
        _this._unmountOverlayTarget = function () {
            if (_this._overlayTarget) {
                _this._portalContainerNode.removeChild(_this._overlayTarget);
                _this._overlayTarget = null;
            }
            _this._portalContainerNode = null;
        };
        _this._renderOverlay = function () {
            var overlay = !_this.props.children
                ? null
                : React.Children.only(_this.props.children);
            // Save reference for future access.
            if (overlay !== null) {
                _this._mountOverlayTarget();
                _this._overlayInstance = ReactDOM.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget);
            }
            else {
                // Unrender if the component is null for transitions to null
                _this._unrenderOverlay();
                _this._unmountOverlayTarget();
            }
        };
        _this._unrenderOverlay = function () {
            if (_this._overlayTarget) {
                ReactDOM.unmountComponentAtNode(_this._overlayTarget);
                _this._overlayInstance = null;
            }
        };
        _this.getMountNode = function () {
            return _this._overlayTarget;
        };
        _this.getOverlayDOMNode = function () {
            if (!_this._isMounted) {
                throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
            }
            if (_this._overlayInstance) {
                if (_this._overlayInstance.getWrappedDOMNode) {
                    return _this._overlayInstance.getWrappedDOMNode();
                }
                else {
                    return ReactDOM.findDOMNode(_this._overlayInstance);
                }
            }
            return null;
        };
        return _this;
    }
    Portal.prototype.componentDidMount = function () {
        this._isMounted = true;
        this._renderOverlay();
    };
    Portal.prototype.componentDidUpdate = function () {
        this._renderOverlay();
    };
    Portal.prototype.componentWillReceiveProps = function (nextProps) {
        if (this._overlayTarget && nextProps.container !== this.props.container) {
            this._portalContainerNode.removeChild(this._overlayTarget);
            this._portalContainerNode = get_container_1.getContainer(nextProps.container, owner_document_1.ownerDocument(this).body);
            this._portalContainerNode.appendChild(this._overlayTarget);
        }
    };
    Portal.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        this._unrenderOverlay();
        this._unmountOverlayTarget();
    };
    Portal.prototype.render = function () {
        return null;
    };
    Portal.propTypes = {
        container: PropTypes.oneOfType([
            react_prop_types_1.componentOrElement,
            PropTypes.func
        ])
    };
    return Portal;
}(React.Component));
exports.Portal = Portal;
